__turbopack_context__.v({
  "btn": "CheckboxField-module-scss-module__nIgbLW__btn",
  "btn-alt": "CheckboxField-module-scss-module__nIgbLW__btn-alt",
  "btn-default": "CheckboxField-module-scss-module__nIgbLW__btn-default",
  "btn-default-dark-bg": "CheckboxField-module-scss-module__nIgbLW__btn-default-dark-bg",
  "btn-disabled": "CheckboxField-module-scss-module__nIgbLW__btn-disabled",
  "btn-elite": "CheckboxField-module-scss-module__nIgbLW__btn-elite",
  "btn-gold": "CheckboxField-module-scss-module__nIgbLW__btn-gold",
  "btn-lg": "CheckboxField-module-scss-module__nIgbLW__btn-lg",
  "btn-link": "CheckboxField-module-scss-module__nIgbLW__btn-link",
  "btn-plat": "CheckboxField-module-scss-module__nIgbLW__btn-plat",
  "btn-primary": "CheckboxField-module-scss-module__nIgbLW__btn-primary",
  "btn-sm": "CheckboxField-module-scss-module__nIgbLW__btn-sm",
  "btn-success": "CheckboxField-module-scss-module__nIgbLW__btn-success",
  "btn-warning": "CheckboxField-module-scss-module__nIgbLW__btn-warning",
  "checkbox": "CheckboxField-module-scss-module__nIgbLW__checkbox",
  "checkboxLabel": "CheckboxField-module-scss-module__nIgbLW__checkboxLabel",
  "container": "CheckboxField-module-scss-module__nIgbLW__container",
  "disabled": "CheckboxField-module-scss-module__nIgbLW__disabled",
  "hasError": "CheckboxField-module-scss-module__nIgbLW__hasError",
  "validation": "CheckboxField-module-scss-module__nIgbLW__validation",
});
